import { render, staticRenderFns } from "./GlobalSnackbarVuex.vue?vue&type=template&id=b38d170c&scoped=true&"
import script from "./GlobalSnackbarVuex.vue?vue&type=script&lang=ts&"
export * from "./GlobalSnackbarVuex.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSnackbarVuex.vue?vue&type=style&index=0&id=b38d170c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38d170c",
  null
  
)

export default component.exports